// Function to add class "active" to the product info drawer box
    function activateProductInfoDrawer() {
        var productInfoDrawer = document.getElementById('product-info-drawer-box');
        if (productInfoDrawer) {
            productInfoDrawer.classList.add('active');
        }
    }

    function deactivateProductInfoDrawer() {
        var productInfoDrawer = document.getElementById('product-info-drawer-box');
        if (productInfoDrawer) {
            productInfoDrawer.classList.remove('active');
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        var productInfoElements = document.querySelectorAll('.product-info');
        productInfoElements.forEach(function(element) {
            element.addEventListener('click', function() {
                activateProductInfoDrawer();
            });
        });
        
        var productInfoClose = document.querySelector('.product-info-close');
       var productInfoClose1 = document.querySelector('.product-info-close-1');
        if (productInfoClose || productInfoClose1) {
            productInfoClose.addEventListener('click', function() {
                deactivateProductInfoDrawer();
            });
          
            productInfoClose1.addEventListener('click', function() {
                deactivateProductInfoDrawer();
            });
        }
    });


// Function to add class "active" to the product info drawer box
    function activateGoodyearDrawer() {
        var goodyearDrawer = document.getElementById('goodyear-walt-box');
        if (goodyearDrawer) {
            goodyearDrawer.classList.add('active');
        }
    }

    function deactivateGoodyearDrawer() {
        var goodyearDrawer = document.getElementById('goodyear-walt-box');
        if (goodyearDrawer) {
            goodyearDrawer.classList.remove('active');
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        var goodyearInfoElements = document.querySelectorAll('.goodyear-info');
        goodyearInfoElements.forEach(function(element) {
            element.addEventListener('click', function() {
                activateGoodyearDrawer();
            });
        });
        
        var goodyearInfoClose = document.querySelector('.goodyear-close');
        var goodyearInfoClose1 = document.querySelector('.goodyear-close-1');
        if (goodyearInfoClose || goodyearInfoClose1) {
            goodyearInfoClose.addEventListener('click', function() {
                deactivateGoodyearDrawer();
            });
            goodyearInfoClose1.addEventListener('click', function() {
                deactivateGoodyearDrawer();
            });
        }
    });




// Function to add class "active" to the product info drawer box
    function activateBlakeStitchedDrawer() {
        var blakeStitchedDrawer = document.getElementById('blake-stitched-box');
        if (blakeStitchedDrawer) {
            blakeStitchedDrawer.classList.add('active');
        }
    }

    function deactivateBlakeStitchedDrawer() {
        var blakeStitchedDrawer = document.getElementById('blake-stitched-box');
        if (blakeStitchedDrawer) {
            blakeStitchedDrawer.classList.remove('active');
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        var blakeStitchedElements = document.querySelectorAll('.blake-stitched-info');
        blakeStitchedElements.forEach(function(element) {
            element.addEventListener('click', function() {
                activateBlakeStitchedDrawer();
            });
        });
        
        var blakeStitchedClose = document.querySelector('.blake-stitched-close');
        var blakeStitchedClose1 = document.querySelector('.blake-stitched-close-1');
        if (blakeStitchedClose || blakeStitchedClose1) {
            blakeStitchedClose.addEventListener('click', function() {
                deactivateBlakeStitchedDrawer();
            });
            blakeStitchedClose1.addEventListener('click', function() {
                deactivateBlakeStitchedDrawer();
            });
        }
    });





// Function to add class "active" to the product info drawer box
    function activateSizeGuideDrawer() {
        var sizeGuideInfoDrawer = document.getElementById('size-guide-box');
        if (sizeGuideInfoDrawer) {
            sizeGuideInfoDrawer.classList.add('active');
        }
    }

    function deactivateSizeGuideDrawer() {
        var sizeGuideInfoDrawer = document.getElementById('size-guide-box');
        if (sizeGuideInfoDrawer) {
            sizeGuideInfoDrawer.classList.remove('active');
        }
    }

    document.addEventListener('DOMContentLoaded', function() {
        var sizeGuideInfoElements = document.querySelectorAll('.size-chart-btn');
        sizeGuideInfoElements.forEach(function(element) {
            element.addEventListener('click', function() {
                activateSizeGuideDrawer();
            });
        });
        
        var sizeGuideInfoClose = document.querySelector('.size-guide-close');
      var sizeGuideInfoClose1 = document.querySelector('.size-guide-close-1');
      
        if (sizeGuideInfoClose || sizeGuideInfoClose1) {
            sizeGuideInfoClose.addEventListener('click', function() {
                deactivateSizeGuideDrawer();
            });
            sizeGuideInfoClose1.addEventListener('click', function() {
                deactivateSizeGuideDrawer();
            });
        }
    });


// Function to update menu detail box with data from header menu item
function updateMenuDetailBoxFromHeaderMenuItem(summaryElement) {
    // Find the closest ".menu-content" element within the closest ".mega-menu"
    const menuContent = summaryElement.closest('.mega-menu').querySelector('.menu-content');

    // Check if menuContent is not null
    if (menuContent) {
        // Get the value of the "data-title" attribute from the header menu item summary
        const title = summaryElement.getAttribute('data-title');

        // Find the ".menu-detail-box" element within the ".menu-content"
        const menuDetailBox = menuContent.querySelector('.menu-detail-box');

        // Check if menuDetailBox is not null
        if (menuDetailBox) {
            // Find the title element within the ".menu-detail-box" and set its text
            const titleElement = menuDetailBox.querySelector('.menu-detail-title');
            if (titleElement) {
                titleElement.textContent = title;
            }

            // Get the value of the "data-subtitle" attribute from the header menu item summary
            const subtitle = summaryElement.getAttribute('data-subtitle');

            // Find the subtitle element within the ".menu-detail-box" and set its text
            const subtitleElement = menuDetailBox.querySelector('.menu-detail-subtitle');
            if (subtitleElement) {
                subtitleElement.textContent = subtitle;
            }

            // Get the value of the "data-detail" attribute from the header menu item summary
            const detail = summaryElement.getAttribute('data-detail');

            // Find the details element within the ".menu-detail-box" and set its text
            const detailElement = menuDetailBox.querySelector('.menu-detail-details');
            if (detailElement) {
                detailElement.textContent = detail;
            }

            // Get the value of the "data-img" attribute from the header menu item summary
            const imgSrc = summaryElement.getAttribute('data-img');

            // Find the image element within the ".menu-detail-box" and set its src attribute
            const imgElement = menuContent.querySelector('.menu-detail-img');
          
            if (imgElement) {
              console.log(imgSrc);
                imgElement.setAttribute('src', imgSrc);
            }
        }
    }
}

// Add event listener to all ".sub-menu-link" elements
document.querySelectorAll('.sub-menu-link').forEach(subMenuLink => {
    // Mouseover event listener
    subMenuLink.addEventListener('mouseover', event => {
        // Call the function to update the menu detail box with data from sub-menu link
        updateMenuDetailBoxFromHeaderMenuItem(subMenuLink);
    });

    // Mouseleave event listener
    subMenuLink.addEventListener('mouseleave', event => {
        // Find the ".header__menu-item" summary element within the closest ".mega-menu"
        const summaryElement = event.target.closest('.mega-menu').querySelector('summary.header__menu-item');

        // Call the function to update the menu detail box with data from header menu item
        updateMenuDetailBoxFromHeaderMenuItem(summaryElement);
    });
});


// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
    // Add a click event listener to the document and delegate it to the button with class "product-form__submit"
    document.addEventListener('click', function(event) {
        if (event.target.classList.contains('product-form__submit')) {
            // Check if the screen size is below 767 pixels
            if (window.innerWidth < 768) {
                // Check if there are any elements with class ".errorOptions" containing specific text
                var errorOptions = document.querySelectorAll('.errorOptions');
                for (var i = 0; i < errorOptions.length; i++) {
                    // Scroll to the element with id "product-info"
                    document.querySelector('#product-info').scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    break; // Stop looping once the first matching element is found
                }
            }
        }
    });
});

// Wait for the document to be fully loaded
// document.addEventListener("DOMContentLoaded", function() {
//     // Delay execution for 100 milliseconds after the DOMContentLoaded event
// setTimeout(function() {
//     // Find the legend element with class name-option and data-name attribute equal to "Select Size"
//     var legendElement = document.querySelector('legend.name-option[data-name="Select Size"]');

//   var ukText = document.createElement('span');
// ukText.textContent = " (UK)";
// ukText.style.fontWeight = "700";
  
//     // Create the button element
//     var sizeChartButton = document.createElement('a');
//     sizeChartButton.href = "#";
//     sizeChartButton.className = "size-chart-btn";
//     sizeChartButton.id= "size-chart-btn";
//     sizeChartButton.textContent = "Size Guide";

//     // Append the button after the legend element
//     var currentUrl = window.location.href.toLowerCase();
//     if (legendElement) {
//         if (legendElement && !currentUrl.includes("belt")){
//             legendElement.appendChild(ukText);
//         }
//         legendElement.appendChild(sizeChartButton);

//       // Event listener for clicking on element with class "product-info"
//         var sizeGuideInfoElements = document.querySelectorAll('.size-chart-btn');
//         sizeGuideInfoElements.forEach(function(element) {
//             element.addEventListener('click', function() {
//                 activateSizeGuideDrawer();
//             });
//         });
        
//         // Event listener for clicking on element with class "product-info-close"
//         var sizeGuideInfoClose = document.querySelector('.size-guide-close');
//         if (sizeGuideInfoClose) {
//             sizeGuideInfoClose.addEventListener('click', function() {
//                 deactivateSizeGuideDrawer();
//             });
//         }
//     }


  
// // Function to handle changes in the name-variant element
// function handleNameVariantChange(mutationsList, observer) {
//     for(const mutation of mutationsList) {
//         if (mutation.type === 'childList') {
//             const swatchGl = document.querySelector('.name-variant').closest('.swatch--gl');
//             if (swatchGl) {
//                 const errorOption = swatchGl.querySelector('.errorOptions');
//                 if (errorOption) {
//                     errorOption.innerHTML = ''; // Remove HTML content
//                 }
//             }
//         }
//     }
// }

//   // Select the target node
// const targetNode = document.querySelector('.name-variant');

// // Options for the observer (which mutations to observe)
// const config = { attributes: false, childList: true, subtree: false };

// // Create a new observer instance
// const observer = new MutationObserver(handleNameVariantChange);

// // Start observing the target node for configured mutations
// if (targetNode) {
//     observer.observe(targetNode, config);
// }
// }, 1000); // Delay in milliseconds

// });

// New code updated 
(function () {
  "use strict";

  const MAX_ATTEMPTS = 10;
  const RETRY_DELAY = 200;

  let attempts = 0;

  function initializeSizeGuide() {
    const legendElement = document.querySelector(
      'legend.name-option[data-name="Select Size"]'
    );

    // Product options are not available yet
    if (!legendElement) {
      return false;
    }

    const currentUrl = window.location.href.toLowerCase();

    // Add UK text only once
    if (
      !currentUrl.includes("belt") &&
      !legendElement.querySelector(".uk-size-label")
    ) {
      const ukText = document.createElement("span");

      ukText.className = "uk-size-label";
      ukText.textContent = " (UK)";
      ukText.style.fontWeight = "700";

      legendElement.appendChild(ukText);
    }

    // Add Size Guide button only once
    let sizeChartButton = legendElement.querySelector(".size-chart-btn");

    if (!sizeChartButton) {
      sizeChartButton = document.createElement("a");

      sizeChartButton.href = "#";
      sizeChartButton.className = "size-chart-btn";
      sizeChartButton.id = "size-chart-btn";
      sizeChartButton.textContent = "Size Guide";

      sizeChartButton.addEventListener("click", function (event) {
        event.preventDefault();

        if (typeof activateSizeGuideDrawer === "function") {
          activateSizeGuideDrawer();
        }
      });

      legendElement.appendChild(sizeChartButton);
    }

    initializeCloseButton();
    initializeNameVariant();

    return true;
  }

  function initializeCloseButton() {
    const closeButton = document.querySelector(".size-guide-close");

    if (!closeButton) {
      return;
    }

    if (closeButton.dataset.initialized === "true") {
      return;
    }

    closeButton.dataset.initialized = "true";

    closeButton.addEventListener("click", function (event) {
      event.preventDefault();

      if (typeof deactivateSizeGuideDrawer === "function") {
        deactivateSizeGuideDrawer();
      }
    });
  }

  function initializeNameVariant() {
    const nameVariant = document.querySelector(".name-variant");

    if (!nameVariant) {
      return;
    }

    const swatchGl = nameVariant.closest(".swatch--gl");

    if (!swatchGl) {
      return;
    }

    const errorOption = swatchGl.querySelector(".errorOptions");

    if (errorOption) {
      errorOption.innerHTML = "";
    }
  }

  function waitForProduct() {
    attempts++;

    const initialized = initializeSizeGuide();

    if (initialized) {
      console.log("Size Guide initialized successfully.");
      return;
    }

    if (attempts < MAX_ATTEMPTS) {
      setTimeout(waitForProduct, RETRY_DELAY);
    } else {
      console.log("Product elements were not found.");
    }
  }

  function start() {
    waitForProduct();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, {
      once: true
    });
  } else {
    start();
  }
})();

document.addEventListener('DOMContentLoaded', function() {
    const bannerSwiper = new Swiper('.home-banner-swiper', {
      loop: true, 
      autoplay: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.home-banner-slider-pagination',
        clickable: true,
      },
      slidesPerView: 1,
    });

      const crosssellSwiper = new Swiper('.cross-sell-products-swiper', {
      loop: false, 
      autoplay: true,
      slidesPerView: 3,
      spaceBetween: 8,
      navigation: {
        nextEl: '.cross-sell-button-next',
        prevEl: '.cross-sell-button-prev',
      },
      pagination: {
        el: '.cross-sell-slider-pagination',
        clickable: true,
      }
    });
});



document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    // Check if the clicked element is a tab link
    if (e.target.classList.contains('cart-tab-link')) {
      e.preventDefault();

      const tabLinks = document.querySelectorAll('.cart-tab-link');
      const tabDetails = document.querySelectorAll('.cart-collection-detail');

      // Remove active classes
      tabLinks.forEach(tab => tab.classList.remove('active'));
      tabDetails.forEach(detail => detail.classList.remove('active'));

      // Add active class to the clicked tab
      e.target.classList.add('active');
      const target = document.querySelector(e.target.getAttribute('href'));
      if (target) {
        target.classList.add('active');
      }
    }
  });
});



  function bindMouseOverToMegaMenu (item) {
    item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
          item.setAttribute("open", true);
        });
        item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  }
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details.mega-menu");
  items.forEach(bindMouseOverToMegaMenu);



// $(document).on("click", ".product-detail-accordion .product-detail-holder h5", function () {
//   $(this).closest(".product-detail-holder").toggleClass("open");
// });
